import useFeatureFlags from 'hooks/useFeatureFlags';

export default (deposits) => {
  const { isEnabled } = useFeatureFlags();
  const loanoutsEnabled = isEnabled('MyCnC-LoanOuts');
  if (!Array.isArray(deposits) || deposits.length === 0) {
    return false;
  }

  if (loanoutsEnabled) {
    if (deposits.filter(d => (d.forCorps || '').toLowerCase() !== 'c').length > 3) {
      return true;
    }
  } else {
    if (deposits.length > 3) {
      return true;
    }
  }

  const count = { amount: 0, percentage: 0 };
  deposits.forEach(deposit => {
    if (deposit.flatAmount) {
      count.amount++;
    }
    if (deposit.flatAmount === 0 && deposit.splitPercentage === 0) {
      count.percentage++;
    }
    if (deposit.splitPercentage) {
      count.percentage++;
    }
  });

  if (count.percentage === 0) {
    return true;
  }

  if (count.percentage > 1 && count.amount > 0) {
    return true;
  }

  return false;
};
